/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uploadimagesforyourlistingdragtoreorderorclicktosetasprimary13Inputs */

const en_uploadimagesforyourlistingdragtoreorderorclicktosetasprimary13 = /** @type {(inputs: Uploadimagesforyourlistingdragtoreorderorclicktosetasprimary13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload images for your listing. The first image is the cover. Drag to reorder, use the star to make another image the cover, or swap the cover in one step with "Replace cover".`)
};

const de_uploadimagesforyourlistingdragtoreorderorclicktosetasprimary13 = /** @type {(inputs: Uploadimagesforyourlistingdragtoreorderorclicktosetasprimary13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lade Bilder für deinen Ort hoch. Das erste Bild ist das Titelbild. Zieh die Bilder, um die Reihenfolge zu ändern, mach mit dem Stern ein anderes Bild zum Titelbild oder tausch es mit „Titelbild ersetzen“ in einem Schritt aus.`)
};

/**
* | output |
* | --- |
* | "Upload images for your listing. The first image is the cover. Drag to reorder, use the star to make another image the cover, or swap the cover in one step wi..." |
*
* @param {Uploadimagesforyourlistingdragtoreorderorclicktosetasprimary13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const uploadimagesforyourlistingdragtoreorderorclicktosetasprimary13 = /** @type {((inputs?: Uploadimagesforyourlistingdragtoreorderorclicktosetasprimary13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uploadimagesforyourlistingdragtoreorderorclicktosetasprimary13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_uploadimagesforyourlistingdragtoreorderorclicktosetasprimary13(inputs)
	return de_uploadimagesforyourlistingdragtoreorderorclicktosetasprimary13(inputs)
});
export { uploadimagesforyourlistingdragtoreorderorclicktosetasprimary13 as "uploadImagesForYourListingDragToReorderOrClickToSetAsPrimary" }